import React from 'react';
import PropTypes from 'prop-types';
import { providers } from '$variables/constants';
import HandinLogo from './handin.svg';
import TurnItInLogo from './turnitin.png';
import QuizzesLogo from './quizzes.png';
import { sizes } from './ProviderLogo.variants';

const { HAND_IN, TURNITIN, QUIZZES } = providers;

const logos = {
  [HAND_IN]: {
    title: 'Handin',
    image: HandinLogo,
  },
  [TURNITIN]: {
    title: 'TurnItIn',
    image: TurnItInLogo,
  },
  [QUIZZES]: {
    title: 'Quizzes',
    image: QuizzesLogo,
  },
};

const ProviderLogo = ({ provider, size }) => {
  const logo = logos[provider];
  const selectedSize = sizes[size];

  if (!logo) {
    return null;
  }

  return (
    <img
      width={selectedSize.width}
      height={selectedSize.height}
      src={logo.image}
      alt={logo.title}
    />
  );
};

ProviderLogo.propTypes = {
  provider: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium']),
};

ProviderLogo.defaultProps = {
  size: 'small',
};

export default ProviderLogo;
